var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-3"},[_vm._t("trigger",null,{"toggle":_vm.toggle})],2),_c('div',{staticClass:"max-h-0 md:max-h-full overflow-hidden transition-[max-height] duration-300 ease-in-out",class:{
      '!max-h-full': _vm.isOpen,
    }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }